import { render } from "./InquiryModify.vue?vue&type=template&id=5c9f665d"
import script from "./InquiryModify.vue?vue&type=script&lang=js"
export * from "./InquiryModify.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__